module.exports = __webpack_public_path__ + "static/7-5-5112be747599f37cbfdeec918be923bf.jpg";